import { render, staticRenderFns } from "./ContentNew.vue?vue&type=template&id=457f0a8a&scoped=true&"
import script from "./ContentNew.vue?vue&type=script&lang=js&"
export * from "./ContentNew.vue?vue&type=script&lang=js&"
import style0 from "./ContentNew.vue?vue&type=style&index=0&id=457f0a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f0a8a",
  null
  
)

export default component.exports